export default {"src":"/_next/static/media/facebook.61359e82.svg","height":27,"width":14,"blurWidth":0,"blurHeight":0};